// src/stone/icons/UserUsers2X.tsx
import { jsx } from "react/jsx-runtime";
var UserUsers2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M2.912 26.246A7.67 7.67 0 0 1 8.333 24h13.334a7.667 7.667 0 0 1 7.666 7.667V35a1 1 0 1 1-2 0v-3.333A5.667 5.667 0 0 0 21.667 26H8.333a5.667 5.667 0 0 0-5.666 5.667V35a1 1 0 1 1-2 0v-3.333c0-2.034.807-3.984 2.245-5.422M15 6a5.667 5.667 0 1 0 0 11.333A5.667 5.667 0 0 0 15 6m-7.667 5.667a7.667 7.667 0 1 1 15.334 0 7.667 7.667 0 0 1-15.334 0M32.365 24.967a1 1 0 0 1 1.218-.719 7.67 7.67 0 0 1 5.75 7.418V35a1 1 0 0 1-2 0v-3.333a5.67 5.67 0 0 0-4.25-5.482 1 1 0 0 1-.718-1.218M25.698 4.969a1 1 0 0 1 1.217-.721 7.667 7.667 0 0 1 0 14.854 1 1 0 0 1-.496-1.937 5.666 5.666 0 0 0 0-10.98 1 1 0 0 1-.721-1.216" })
  }
);
var UserUsers2X_default = UserUsers2X;

export {
  UserUsers2X,
  UserUsers2X_default
};
